var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.gcsSignInSheetTemplate!='')?_c('div',{staticClass:"active-reports",staticStyle:{"height":"100vh"},attrs:{"id":"active-reports"}},[_c('GcArViewer',{ref:"reportViewer",attrs:{"theme":"ActiveReports","availableExports":_vm.availableExports,"sidebarVisible":true},on:{"viewerLoaded":_vm.onViewerLoaded}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }